import axios from "axios";

const API = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/api`
      : "https://igembe-south-digital-bursary-system.onrender.com/api"
});

/* Attach JWT token */
API.interceptors.request.use((config) => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
  } catch (err) {
    console.error("Invalid user in localStorage");
  }

  return config;
});

/* Auto logout on 401 */
API.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default API;